import HelpIcon from "@material-ui/icons/Help"
import Tooltip from "@material-ui/core/Tooltip"
import Typography from "@material-ui/core/Typography"

const ICON_SIZE = 20

const HelpTooltip = props => {
    const { IconProps, ...rest } = props
    return (
        <Tooltip {...rest} title={<Typography>{rest.title}</Typography>}>
            <HelpIcon
                {...IconProps}
                style={{ ...IconProps?.style, width: ICON_SIZE, height: ICON_SIZE }}
                color="action"
            />
        </Tooltip>
    )
}

export default HelpTooltip
